module.exports = __webpack_public_path__ + "static/018-aa934c860df97deb393e6acb1ca9dd55.png";